
import { Component, Prop, Vue } from 'vue-property-decorator';
import * as ClaimCategoryService from '@/services/ClaimCategoryService';
import { ClaimCategory } from '@/types';

/** Factcheck categories, picked by name; stores their ids. */
@Component
export default class CategoryField extends Vue {
  @Prop({ required: true }) readonly value!: string[];
  @Prop({ required: true }) readonly label!: string;
  @Prop({ default: '' }) readonly hint!: string;
  @Prop({ type: Array, default: () => [] }) readonly errorMessages!: string[];

  categories: ClaimCategory[] = [];
  loading = false;

  /** Ids that are no longer a category still show, so they can be removed. */
  get items(): ClaimCategory[] {
    const known = new Set(this.categories.map((category) => category.id));
    const unknown = this.value.filter((id) => !known.has(id)).map((id) => ({ id, nl: `Onbekende categorie (${id})` }));
    return [...this.categories, ...unknown];
  }

  async mounted(): Promise<void> {
    this.loading = true;
    try {
      const categories = await ClaimCategoryService.GetClaimCategories();
      this.categories = [...categories].sort((a, b) => a.nl.localeCompare(b.nl, 'nl'));
    } catch (error) {
      this.categories = [];
    }
    this.loading = false;
  }

  onChange(next: string[] | null): void {
    this.$emit('input', Array.isArray(next) ? next : []);
  }
}
